import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { TaxClass, TaxClassCreate, TaxClassFilter } from '../data/taxClass';

export function createTaxClassService(client: AxiosInstance) {
  return createCrudService<TaxClass, TaxClassCreate, TaxClassFilter>(
    client,
    '/master-data/TaxClass',
    'id',
  );
}

export type TaxClassService = CrudService<TaxClass, TaxClassCreate, TaxClassFilter>;
